import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export interface LeadGroup {
  _id?:    string;
  name:    string;
  colour?: string;
  color?:  string;
  clientsAssigned?: number;
  count?:  number;
}

export const leadGroupsApi = createApi({
  reducerPath: 'leadGroupsApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['LeadGroups'],
  endpoints: (builder) => ({
    getLeadGroups: builder.query<any, void>({
      query: () => ({ url: '/lead-groups', method: 'GET' }),
      providesTags: ['LeadGroups'],
    }),
    createLeadGroup: builder.mutation<any, { name: string; colour: string }>({
      query: (body) => ({ url: '/lead-groups', method: 'POST', body }),
      invalidatesTags: ['LeadGroups'],
    }),
    updateLeadGroup: builder.mutation<any, { id: string; name?: string; colour?: string }>({
      query: ({ id, ...body }) => ({ url: `/lead-groups/${id}`, method: 'PATCH', body }),
      invalidatesTags: ['LeadGroups'],
    }),
    deleteLeadGroup: builder.mutation<any, string>({
      query: (id) => ({ url: `/lead-groups/${id}`, method: 'DELETE' }),
      invalidatesTags: ['LeadGroups'],
    }),
  }),
});

export const {
  useGetLeadGroupsQuery,
  useCreateLeadGroupMutation,
  useUpdateLeadGroupMutation,
  useDeleteLeadGroupMutation,
} = leadGroupsApi;
